import claimPwd from './src/ClaimPwd.vue';

claimPwd.install = function (app) {
  app.component(claimPwd.name, claimPwd)
}

export default claimPwd


//////////////////
// WEBPACK FOOTER
// ./packages/claim/index.js
// module id = null
// module chunks = 